import { EnvName } from './env-name';

export const environment = {
  production: true,
  envName: 'dev' as EnvName,
  apiURL: 'https://dev.boblak.rs/api/v1',
};
